import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const featureBannerWrapper = ({ theme }: { theme: Theme }) => css`
  box-sizing: border-box;
  padding: ${theme.spacing(3)} 0;
  display: flex;
  gap: ${theme.spacing(3)};
  justify-content: center;
  align-items: center;
  background: #f0f4f9;
  font-weight: 500;
  font-size: 13px;
`
export const featureBannerPill = () => css`
  padding: 1px 9px;
  background: #044576;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 50px;
`

export const featureBannerTypography = () => css`
  font-weight: 500;
  color: #002a4a;
`

export const featureBannerLink = () => css`
  font-weight: 700;
  color: #0074d3;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`
